module.exports = __webpack_public_path__ + "static/media/team-image-2.f673cd08.webp";